import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import snack from '@/helpers/snack'
import serverError from '@/helpers/server_error'

export default {
  GET_GOOD_ORDERS: ({ commit, state }, payload) => {
    if (payload.showPreloader) {
      commit('setLoad', true)
    }

    if (payload.params.offset === 0) {
      commit('setGoodOrders', [])
    }

    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.all}`,
        {
          params: payload.params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('updateGoodOrders', data.items)
          commit('setGoodOrderFilters', data.filters)
          resolve(data.count)
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  GET_GOOD_ORDER_STATUSES: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.status}`, {}, true).then(
        response => {
          const data = response.data.data
          commit('setGoodOrderStatuses', data)
        },
      )

      resolve()
    })
  },
  GET_GOOD_ORDER: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.one.replace('$1', payload.item)}`,
        {
          params: {
            with: 'employer;unit;store;items.good;items.goodGroup;items.product;items.good.goodType',
          },
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setGoodOrderItems', data.items)
          delete data.items
          commit('setGoodOrder', data)
          resolve()
        })
        .catch(error => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  async CREATE_GOOD_ORDER({ commit, state }, payload) {
    commit('setLoad', true)
    try {
      const {
        data: { data },
      } = await request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.all}`,
        payload.params,
        true,
      )
      commit('setGoodOrder', data)
      router.push({ path: Vue.config.modules.crm.route.goodOrders.one.replace('$1', data.id), hash: '#tab-0' })
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } catch (error) {
      snack.add(Vue.config.localization.ru.errorSavingMessage)
    }
    commit('setLoad', false)
  },
  async UPDATE_GOOD_ORDER({ commit, state }, payload) {
    commit('setLoad', true)
    try {
      const response = await request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.one.replace('$1', payload.id)}`,
        payload.params,
        true,
      )
      commit('setGoodOrder', response.data.data)
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } catch (error) {
      snack.add(Vue.config.localization.ru.errorSavingMessage)
    }
    commit('setLoad', false)
  },
  async DELETE_GOOD_ORDER({ commit, state, dispatch }, payload) {
    commit('setLoad', true)
    try {
      const response = await request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.one.replace('$1', payload.id)}`,
        {},
        true,
      )
      commit('setGoodOrder', response.data.data)
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')

      commit('deleteGoodOrder', payload.id)
      commit('setGoodOrder', [])
      router.push({ path: Vue.config.modules.crm.route.goodOrders.all })
      snack.add(Vue.config.localization.ru.deleteMessage, 'primary')
    } catch (error) {
      snack.add(Vue.config.localization.ru.errorDeletingMessage)
    }
    commit('setLoad', false)
  },
  PROCESS_GOOD_ORDER: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.process.replace('$1', payload.id)}`,
        {
          params: {
            with: 'unit;store;employer;items.good;items.goodGroup;items.product',
          },
        },
        true,
      )
        .then(response => {
          const data = response.data
          commit('setGoodOrderItems', data.data.items)
          delete data.data.items
          commit('setGoodOrder', data.data)

          snack.add(Vue.config.localization.ru.goodOrderOk, 'primary')
          if (data.left > 0) {
            snack.add(Vue.config.localization.ru.goodOrderLeft.replace('$1', data.left), 'info')
          }
          resolve()
        })
        .catch((error, response) => {
          serverError.notify(error, 'goodOrderValidation')
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  REFRESH_GOOD_PRODUCTS: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrders.refresh.replace('$1', payload.id)}`,
        {
          params: {
            with: 'good;goodGroup;product',
          },
        },
        true,
      )
        .then(response => {
          if (response.data.result === 'success') {
            const data = response.data.data
            commit('setGoodOrderItems', data)

            snack.add(Vue.config.localization.ru.refreshedMessage, 'primary')
          } else {
            snack.add(Vue.config.localization.ru.refreshedErrorMessage)
          }
        })
        .catch(() => {
          snack.add(Vue.config.localization.ru.refreshedErrorMessage)
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  GET_GOOD_ORDER_ITEMS: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrderItems.items.replace('$1', payload.item)}`,
        {
          params: {
            with: 'good;goodGroup;product',
          },
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setGoodOrderItems', data)
          resolve()
        })
        .catch(error => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  GET_GOOD_ORDER_PRODUCTS: ({ commit, state, getters }, payload) => {
    if (payload.params.offset === 0 && getters.goodOrderProducts.length > 0) {
      commit('setGoodOrderProducts', [])
    }

    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrderProducts.all}`,
        {
          params: payload.params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setGoodOrderProducts', state.goodOrderProducts.concat(data.items))
          resolve()
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.loadingError, 'error')
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  SYNC_ITEMS: ({ commit, state, getters }, payload) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api[payload.module].all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      const data = response.data.data
      commit('setSyncItems', data.items)
    })
  },

  async UPDATE_GOOD_ORDER_PRODUCT_BY_ID({ commit, state }, payload) {
    try {
      const response = await request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrderProducts.one.replace('$1', payload.id)}`,
        payload.fields,
        true,
      )
      if (response.data.result === 'success') {
        snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        if (_.isFunction(payload.onSuccess)) {
          payload.onSuccess()
        }
      }
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.errors.savingGoodError)
    }
  },

  async CREATE_GOOD_ORDER_ITEM({ commit, state }, payload) {
    try {
      const response = await request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrderItems.all}`,
        {
          params: {
            ...payload.props,
            with: 'good;goodGroup;product;good.goodType',
          },
        },
        true,
      )
      commit('addGoodOrderItem', response.data.data)
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } catch (error) {
      snack.add(Vue.config.localization.ru.errorSavingMessage)
    }
  },
  async UPDATE_GOOD_ORDER_ITEM({ commit, state }, payload) {
    try {
      const response = await request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrderItems.one.replace('$1', payload.id)}`,
        {
          params: {
            ...payload.props,
            with: 'good;goodGroup;product',
          },
        },
        true,
      )
      commit('changeGoodOrderItem', response.data.data)
      snack.add(Vue.config.localization.ru.savedMessage, 'primary')
    } catch (error) {
      snack.add(Vue.config.localization.ru.errorSavingMessage)
    }
  },
  async DELETE_GOOD_ORDER_ITEM({ commit, state, dispatch }, payload) {
    try {
      const response = await request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrderItems.one.replace('$1', payload.id)}`,
        {},
        true,
      )
      commit('deleteGoodOrderItem', payload.id)
      snack.add(Vue.config.localization.ru.deleteMessage, 'primary')
    } catch (error) {
      snack.add(Vue.config.localization.ru.errorDeletingMessage)
    }
  },

  ADD_GOOD_ORDER_ITEMS: ({ commit, state }, payload) => {
    commit('setLoad', true)

    return new Promise((resolve, reject) => {
      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodOrderItems.items.replace('$1', payload.id)}`,
        {
          items: payload.items,
          with: 'good;goodGroup;product;good.goodType',
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setGoodOrderItems', data)
          resolve()
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.savedErrorMessage)
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },

  async GET_GOOD_ORDERS_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_UNITS', { params: { filter: 'id;name' } }),
      dispatch('GET_STORES', { params: { filter: 'id;title' } }),
      // dispatch('GET_GOOD_GROUPS', {}),
      dispatch('GET_GOOD_ORDER_STATUSES', { params: {} }),
    ])
    commit('setLoad', false)
  },
  async GET_GOOD_ORDER_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_GOOD_ORDER', payload),
      dispatch('GET_UNITS', { params: { filter: 'id;name' } }),
      dispatch('GET_STORES', { params: { filter: 'id;title' } }),
      // dispatch('GET_GOOD_GROUPS', {}),
      dispatch('GET_GOOD_ORDER_STATUSES', payload),
    ])
    commit('setLoad', false)
  },
  async GET_GOOD_ORDER_WITH_ITEMS({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([dispatch('GET_GOOD_ORDER', payload), dispatch('GET_GOOD_ORDER_ITEMS', payload)])
    commit('setLoad', false)
  },
}
